export default "__VITE_ASSET__CXrZHRL2__"